// extracted by mini-css-extract-plugin
export default {"menu-item":"menuItemStyled_menu-item__XP7Hb"};